// extracted by mini-css-extract-plugin
export default {"overlay":"mB-z","bodyOpen":"nB-z","content":"oB-z","header":"pB-z","close":"qB-z","closeNoHeading":"rB-z"};